import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

const inputVariants = cva(
  'w-full min-w-0 border border-input inset-shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
  {
    variants: {
      inputSize: {
        default: 'h-9 rounded-md px-3 py-1 text-base md:text-sm',
        sm: 'h-6 rounded-sm px-1.5 py-1 text-sm',
        inlineEdit:
          'h-full rounded-sm border-0 px-0 py-0 text-sm text-inherit inset-shadow-none focus-visible:border-0 focus-visible:ring-0 focus-visible:outline-none',
      },
      backgroundColor: {
        default: 'bg-transparent',
        surface: 'bg-input',
      },
    },
    defaultVariants: {
      inputSize: 'default',
      backgroundColor: 'default',
    },
  }
)

type InputProps = React.ComponentProps<'input'> &
  VariantProps<typeof inputVariants>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize, backgroundColor, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot='input'
        ref={ref}
        data-size={inputSize}
        className={cn(inputVariants({ inputSize, backgroundColor, className }))}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input, inputVariants }
